export const queryKeys = {
    TOPIC_AUTO_TESTS: "topic-auto-tests"
}